import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import isEmpty from 'lodash/isEmpty'
import IconCaretDown from '@vtex/styleguide/lib/icon/CaretDown'

import PaymentItem from '@/checkout-instore-legacy/components/Commons/PaymentItem'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'

import PrintReceipt from './PrintReceipt'

class OrderPlacedPayment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDetails: false,
    }
  }

  handleShowInfo = () => {
    logClickEvent('show-order-details', 'Sale')
    this.setState({ showDetails: true })
  }

  render() {
    const { payment, location } = this.props
    const paymentGroupName = `${payment.group}PaymentGroup`
    let paymentIdText
    if (payment.id) {
      paymentIdText = (
        <div className="lh-copy mv3 mv4-ns f4-ns pb6-l">
          <strong>
            <FormattedMessage id="orderPlacedPaymentId" />
          </strong>
          {': '}
          {payment.id}
        </div>
      )
    }

    let transactionIdText
    if (payment.tid || payment.transactionId) {
      transactionIdText = (
        <div>
          <strong>
            <FormattedMessage id="orderPlacedTransactionId" />
          </strong>
          {': '}
          {payment.tid || payment.transactionId}
        </div>
      )
    }

    const { connectorResponses } = payment

    const printImmediately =
      location && location.query && location.query.printImmediately !== 'false'
    const { printingConfig } = getInstoreConfig()
    const automaticallyPrintMerchantReceipt =
      printImmediately &&
      printingConfig &&
      printingConfig.printReceiptsAutomatically &&
      printingConfig.printReceiptsAutomatically.merchant
    const automaticallyPrintCustomerReceipt =
      printImmediately &&
      printingConfig &&
      printingConfig.printReceiptsAutomatically &&
      printingConfig.printReceiptsAutomatically.customer

    return (
      <div className="bb b--black-10 ph6-l pt5-l pb5-l no-print-spaces">
        <PaymentItem
          className="no-print-spaces"
          key={payment.paymentSystem}
          paymentName={payment.paymentSystemName}
          groupName={paymentGroupName}
          onClick={this.handleShowInfo}
          value={payment.value}
          installmentsAsOffer={false}
          numberOfInstallments={payment.installments}
          flexNowrap={false}
        >
          {this.state.showDetails ? (
            <div
              className="w-100 mt4 flex-none"
              style={{ wordWrap: 'break-word' }}
            >
              {paymentIdText}
              {transactionIdText}
            </div>
          ) : (
            <div className="mr5 self-center no-print">
              <IconCaretDown />
            </div>
          )}
        </PaymentItem>
        {!isEmpty(connectorResponses) && (
          <div className="no-print flex-ns pl5 pl6-ns ml8 ml9-ns mb6">
            <div className="ml4 ml0-ns">
              {connectorResponses.inStoreMerchantReceipt && (
                <PrintReceipt
                  receipt={connectorResponses.inStoreMerchantReceipt}
                  labelId="orderPlacedPrintCardMerchantReceipt"
                  automaticallyPrintReceipt={automaticallyPrintMerchantReceipt}
                />
              )}
            </div>
            <div className="mt1 mt0-ns ml4 ml7-ns">
              {connectorResponses.inStoreCustomerReceipt && (
                <PrintReceipt
                  receipt={connectorResponses.inStoreCustomerReceipt}
                  labelId="orderPlacedPrintCardCustomerReceipt"
                  automaticallyPrintReceipt={automaticallyPrintCustomerReceipt}
                />
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

OrderPlacedPayment.propTypes = {
  payment: PropTypes.object.isRequired,
  location: PropTypes.object,
}

export default withRouter(OrderPlacedPayment)
